export default `float e = 1., g=0;
  for ( int i=0;i++<7;p=abs(p)-vec3(2.0,1.0,.2))
    p = 0.22-abs(abs(p)-.06),
    p = p.x>p.y?p.zxy:p.zyx,
    p *= 2.,
    e *= 2.,
    p.xz *= rotate2D(-.6);
    p /= e;
    g += e = length(p.xy);
  return e;
}`